const API_URL = import.meta.env.VITE_API_URL as string

// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import getPharmacyID from "@/utils/pharmacy_code";
import { PatientSearchParams } from "@/routes/(pharma)/_layout/patients/-data/schema";
import { httpClient } from "@/httpClient";
import { Loading } from "@/layouts/loading";
import { ListPatientsResponse } from "@/gen/patients/list_patients_pb";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/patients/")({
  component: Component,
  validateSearch: PatientSearchParams
});